import React, { useEffect } from "react";
import { Locale } from "../translations/locale";
import { locales } from "./locales";
import { useEnvironments } from "../environments/hooks";
import { ScheduleItem } from "./ScheduleItem";
import "./styles.css";

const environmentColumn = {
	width: "50%",
	margin: "2px",
};

export const Scheduler = () => {
	const { environments, refetchEnvironments } = useEnvironments();

	useEffect(() => {
		setInterval(() => {
			refetchEnvironments();
		}, 10000);
	}, []);

	return !!environments && environments.length > 0 ? (
		<div>
			<h1>
				<Locale id={"header"} locales={locales}>
					Start Environments
				</Locale>
			</h1>
			<div style={{ flexDirection: "row", display: "flex" }}>
				<div style={environmentColumn}>
					{environments
						.sort((a, b) =>
							a.name > b.name ? 1 : b.name > a.name ? -1 : 0
						)
						.map((environment, index) =>
							index % 2 <= 0 ? (
								<ScheduleItem
									key={index}
									environment={environment}
								/>
							) : null
						)}
				</div>
				<div style={environmentColumn}>
					{environments
						.sort((a, b) =>
							a.name > b.name ? 1 : b.name > a.name ? -1 : 0
						)
						.map((environment, index) =>
							index % 2 > 0 ? (
								<ScheduleItem
									key={index}
									environment={environment}
								/>
							) : null
						)}
				</div>
			</div>
		</div>
	) : null;
};
